import { SVGProps } from 'react';

const SvgWineGlass = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 320 512"
    width="1em"
    height="1em"
    {...props}
  >
    <path d="M184 464V350c44.4-7.5 81.5-35.5 101.7-73.6 13.6-24.4 20.4-53.2 17.7-83.7L287.5 14.5C286.8 6.2 279.9 0 271.8 0H48.2c-8.1 0-15 6.2-15.8 14.5L16.6 192.6c-2.7 30.5 4 59.3 17.7 83.7C54.5 314.5 91.6 342.5 136 350v114H72c-1 0-2.1.1-3.1.2C57.1 465.7 48 475.8 48 488c0 12.2 9.1 22.2 20.8 23.8.9.1 1.9.2 2.9.2H248c1 0 2.1-.1 3.1-.2 11.8-1.5 20.9-11.6 20.9-23.8 0-12.2-9.1-22.2-20.8-23.8-.9-.1-1.9-.2-2.9-.2H184zM78.2 48h163.6l6.3 80H71.9l6.3-80zM68.1 176h183.8l2.1 26.3c4.3 54.8-39 101.7-94 101.7s-98.3-46.9-94-101.7l2.1-26.3z" />
  </svg>
);
export default SvgWineGlass;
